import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="response" id="response"></a>
    <h1 {...{
      "id": "windowresponse"
    }}>{`window.Response`}</h1>
    <p>{`Response class represents a resource request.`}</p>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <a name="new-response-new" id="new-response-new"></a>
    <h2 {...{
      "id": "responsebody-options"
    }}>{`Response(`}{`[body]`}{`, `}{`[options]`}{`)`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[body]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Blob`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`TypedArray`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`FormData`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ReadableStream`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`URLSearchParams`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`null`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Body of the response.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Custom settings that you want to apply to the response.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.status]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`200`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Status code of the response.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.statusText]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Status message associated with the status code. The default value is "".`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.headers]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Headers`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Any headers that you want to add to the response.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="response-body" id="response-body"></a>
    <h2 {...{
      "id": "body--readablestream"
    }}>{`body : `}<inlineCode parentName="h2">{`ReadableStream`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
ReadableStream object with the body contents or null if response's body is empty.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/body"
      }}>{`Response - body`}</a>{`  `}</p>
    <a name="response-bodyused" id="response-bodyused"></a>
    <h2 {...{
      "id": "bodyused--boolean"
    }}>{`bodyUsed : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicates whether the response body has been read yet.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/bodyUsed"
      }}>{`Response - bodyUsed`}</a>{`  `}</p>
    <a name="response-headers" id="response-headers"></a>
    <h2 {...{
      "id": "headers--headers"
    }}>{`headers : `}<inlineCode parentName="h2">{`Headers`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
`}<a parentName="p" {...{
        "href": "./Headers.md"
      }}>{`Headers`}</a>{` object associated with the response.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/headers"
      }}>{`Response - headers`}</a>{`  `}</p>
    <a name="response-ok" id="response-ok"></a>
    <h2 {...{
      "id": "ok--boolean"
    }}>{`ok : `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Indicates whether the response was successful (if status is in range 200-299) or not.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/ok"
      }}>{`Response - ok`}</a>{`  `}</p>
    <a name="response-status" id="response-status"></a>
    <h2 {...{
      "id": "status--number"
    }}>{`status : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
HTTP status codes of the response.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/status"
      }}>{`Response - status`}</a>{`  `}</p>
    <a name="response-statustext" id="response-statustext"></a>
    <h2 {...{
      "id": "statustext--string"
    }}>{`statusText : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Status message corresponding to the HTTP status code. Default is "".`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/statusText"
      }}>{`Response - statusText`}</a>{`  `}</p>
    <a name="response-url" id="response-url"></a>
    <h2 {...{
      "id": "url--string"
    }}>{`url : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
URL of the response.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/url"
      }}>{`Response - url`}</a>{`  `}</p>
    <a name="response-arraybuffer" id="response-arraybuffer"></a>
    <h2 {...{
      "id": "arraybuffer"
    }}>{`arrayBuffer()`}</h2>
    <p>{`Reads the response stream to completion and returns it as a Promise that resolves with an ArrayBuffer.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<ArrayBuffer>`}</inlineCode>{` Promise that resolves with an ArrayBuffer.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/arrayBuffer"
      }}>{`Response - arrayBuffer`}</a>{`  `}</p>
    <a name="response-blob" id="response-blob"></a>
    <h2 {...{
      "id": "blob"
    }}>{`blob()`}</h2>
    <p>{`Reads the response stream to completion and returns it as a Promise that resolves with a Blob.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Blob>`}</inlineCode>{` Promise that resolves with a Blob.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/blob"
      }}>{`Response - blob`}</a>{`  `}</p>
    <a name="response-clone" id="response-clone"></a>
    <h2 {...{
      "id": "clone"
    }}>{`clone()`}</h2>
    <p>{`Creates a copy of the current response object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Response`}</inlineCode>{` - Copy of the response.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/clone"
      }}>{`Response - clone`}</a>{`  `}</p>
    <a name="response-formdata" id="response-formdata"></a>
    <h2 {...{
      "id": "formdata"
    }}>{`formData()`}</h2>
    <p>{`Reads the response stream to completion and returns it as a Promise that resolves with a FormData.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<FormData>`}</inlineCode>{` Promise that resolves with a FormData.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/formData"
      }}>{`Response - formData`}</a>{`  `}</p>
    <a name="response-json" id="response-json"></a>
    <h2 {...{
      "id": "json"
    }}>{`json()`}</h2>
    <p>{`Reads the response stream to completion and
returns it as a Promise that resolves with the result of parsing the body text as JSON.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Object>`}</inlineCode>{` Promise that resolves to JSON object.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/json"
      }}>{`Response - json`}</a>{`  `}</p>
    <a name="response-text" id="response-text"></a>
    <h2 {...{
      "id": "text"
    }}>{`text()`}</h2>
    <p>{`Reads the response stream to completion and returns it as a Promise that resolves with a String decoded using UTF-8.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<string>`}</inlineCode>{` Promise that resolves with a String.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/text"
      }}>{`Response - text`}</a>{`  `}</p>
    <a name="response-error" id="response-error"></a>
    <h2 {...{
      "id": "error"
    }}>{`error()`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Response`}</inlineCode>{` - Response object`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/error_static"
      }}>{`Response - error`}</a>{`  `}</p>
    <a name="response-redirect" id="response-redirect"></a>
    <h2 {...{
      "id": "redirecturl-status"
    }}>{`redirect(url, `}{`[status]`}{`)`}</h2>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Response`}</inlineCode>{` - Response object`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`RangeError`}</inlineCode>{` If status is not one of 301, 302, 303, 307, 308.`}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Response/redirect_static"
      }}>{`Response - redirect`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`URL that the new response is to originate from.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[status]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`302`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Status code for the response. Possible values are 301, 302, 303, 307 and 308.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      